import { GetDashboardResponse } from '@blockworks/platform/api/research/studio/dashboard';
import { studioExecutionApi } from '@blockworks/platform/api/research/studio/execution';

import { getTableVisualizationPageSize } from '../../visualization';

import { getPreloadableVisualizations } from './get-preloadable-visualizations';

const fetchPreloadedVisualizationData = async (dashboard: GetDashboardResponse['data'], visualizationId: string) => {
    const visualizationInDashboard = dashboard.visualizations.find(v => v.id === visualizationId);
    if (!visualizationInDashboard) {
        console.error('Visualization not found in dashboard.', {
            visualizationId: visualizationId,
            dashboardId: dashboard.id,
        });

        return null;
    }

    const maybeTablePageSize = getTableVisualizationPageSize(visualizationInDashboard.config);

    if (dashboard.isPublic) {
        const { data } = await studioExecutionApi.useGetExecution.fetcher({
            id: visualizationInDashboard.lastExecutionId,
            limit: maybeTablePageSize,
        });

        return {
            ...visualizationInDashboard,
            execution: data,
        };
    }

    const preloadableVisualizations = getPreloadableVisualizations(dashboard);

    const visualizationIsInTopVisualizations = preloadableVisualizations.some(
        v => v.id === visualizationInDashboard.id,
    );

    if (visualizationIsInTopVisualizations) {
        const { data } = await studioExecutionApi.useGetExecution.fetcher({
            id: visualizationInDashboard.lastExecutionId,
            limit: maybeTablePageSize,
        });

        return {
            ...visualizationInDashboard,
            execution: data,
        };
    }

    return visualizationInDashboard;
};

export { fetchPreloadedVisualizationData };
